<template>
  <div class="print-description-wrapper">
    <div class="total-title">360 云打印彩色打印手册</div>
    <div style="margin-bottom: 20px;">
      使用说明：
      <br />
      <span class="weight">1、彩色扫描：</span>无需申请，默认都有权限，可以选择扫描色彩为“全彩”。
      <br />
      <span class="weight">2、彩色打印/复印：</span>默认可以进行黑白色打印，彩色打印需要进行申请，申请路径：手机推推-工作台-IT相关-彩打申请。
      <br />
      <span class="weight">3、为避免浪费，电脑默认打印设置为黑白打印，如有需要申请权限后，按需彩色打印。</span>
      <br />
      <span class="weight">
        <br />信息化部服务台
        <br />报障电话：010-58781234
        <br />报障邮箱：IT@360.cn
      </span>
      <br />
    </div>
    <section>
      <div class="title">1. 彩色打印自助申请</div>
      <div class="sub-title">1.1 安装推推移动端APP</div>
      <p>请从下方链接或根据机型扫描下方二维码进行下载安装</p>
      <p>
        iPhone 客户端：
        <a
          href="https://itunes.apple.com/cn/app/360/id1450482195?mt=8"
        >https://itunes.apple.com/cn/app/360/id1450482195?mt=8</a>
      </p>
      <p>
        Android 客户端：
        <a
          href=" http://down.360safe.com/itdev/android/IQHAMaster.apk"
        >http://down.360safe.com/itdev/android/IQHAMaster.apk</a>
      </p>
      <p class="textcenter">
        <span class="weight">IOS客户端下载</span>
        <img src="../../assets/img/print/img_1.png" alt />
      </p>
      <p class="textcenter">
        <span class="weight">Android客户端（不支持微信扫一扫）</span>
        <img src="../../assets/img/print/img_2.png" alt />
      </p>
      <div class="sub-title">1.2 推推APP移动端申请彩打权限</div>
      <p class="weight">申请批准后，系统会自动开通彩打权限。</p>
      <img src="../../assets/img/print/img_3.png" alt />
      <img src="../../assets/img/print/img_4.png" alt />
    </section>
    <section>
      <div class="title">2. Windows 系统彩色打印设置</div>
      <div class="sub-title">2.1 使用 office 文档彩色打印：</div>
      <p>
        打印 office 任一文件，如 Word，点击文件-打印-打印机，选择 360 云打印，
        点击打印属性，将色彩模式更改为彩色，点击确定即可打印彩色。
      </p>
      <p>
        <img :src="img_04" alt />
        <img :src="img_05" alt />
      </p>
      <div class="sub-title">2.2 使用 360 浏览器或者谷歌浏览器打印彩色设置：</div>
      <p class="weight">
        打开任一网页，右击页面打印--点击“使用系统对话框进行打印”—点击“首选
        项”—更改色彩模式为彩色，点击确定即可打印彩色。
      </p>
      <p>
        <img :src="img_07" alt />
        <img :src="img_08" alt />
      </p>
      <div class="sub-title">2.3 使用 PDF 进行彩色打印设置：</div>
      <p class="weight">
        打开任何一 PDF 文件，点击 PDF 左上角文件—点击打印—选择打印机为 360
        云打印—点击属性---更改色彩模式为彩色，点击确定即可打印彩色。
      </p>
      <p>
        <img :src="img_10" alt />
      </p>
      <div class="title margin">3. MAC 系统彩色打印设置</div>
      <p>随便选择一个文件,如 office 文档，浏览器，图片等，点击打印，选择“360 云打印“。</p>
      <p>
        <img :src="img_11" alt />
        <img :src="img_12" alt />
      </p>
      <p>如果需要打印彩色，选择显示详细信息，“Fuji Xerox Features”, 选择“Color”。</p>
      <p>
        <img :src="img_13" alt />
        <img :src="img_14" alt />
      </p>
      <p>
        如要设置成默认为
        <span class="weight">彩色打印</span>，点击预置—将当前设置存储为预置。可以设定一个打印机名称如“360Print” 。
      </p>
      <p>
        <img :src="img_15" alt />
      </p>
    </section>
    <div class="title">4. 彩色复印/扫描</div>
    <p>彩色复印：放入文件，在打印机上直接选择复印，色彩模式更改为彩色，点击启动即可。</p>
    <p>
      <img :src="img_16" alt />
    </p>
    <p>彩色扫描：放入文件，直接点击扫描，更改色彩模式为全彩，点击启动即可。</p>
    <p>
      <img :src="img_17" alt />
    </p>
  </div>
</template>
<script>

import img_04 from '@/assets/img/print/img_04.png'
import img_05 from '@/assets/img/print/img_05.png'
import img_07 from '@/assets/img/print/img_07.png'
import img_08 from '@/assets/img/print/img_08.png'
import img_10 from '@/assets/img/print/img_10.png'
import img_11 from '@/assets/img/print/img_11.png'
import img_12 from '@/assets/img/print/img_12.png'
import img_13 from '@/assets/img/print/img_13.png'
import img_14 from '@/assets/img/print/img_14.png'
import img_15 from '@/assets/img/print/img_15.png'
import img_16 from '@/assets/img/print/img_16.png'
import img_17 from '@/assets/img/print/img_17.png'
export default{
  data(){
    return {
      img_04,
      img_05,
      img_07,
      img_08,
      img_10,
      img_11,
      img_12,
      img_13,
      img_14,
      img_15,
      img_16,
      img_17,
    }
  }
}
</script>
<style lang="scss" scoped>
.print-description-wrapper {
  min-height: 100vh;
  padding: 15px;
  background: #fff;
  font-size: 14px;
  img {
    width: 100%;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  p {
    margin: 1em 0;
  }
  .sub-title {
    font-weight: bold;
  }
  .total-title {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    padding: 1em 0;
  }
  .weight {
    font-weight: bold;
  }
  .textcenter {
    text-align: center;
  }
  a {
    color: $link-a;
  }
  img {
    margin: 0.5em 0;
  }
}
</style>